/**
 * 我采购的排名列表地址
 */
export const RANKING_AUCTION_PURCHASE_LIST_PAGE_PATH =
  '/auction/ranking/list/purchase'
